export default __webpack_public_path__ + "5e36706677e3ae416f1ee11dfe9c0f11.png";